<template>
  <div class="icell-wrap">
    <div class="title van-multi-ellipsis--l2">
      <div class="text">{{dataItem.title}}</div>
      <div class="is_new" v-if="dataItem.is_new">
        <div class='is_new_item'></div>
      </div>
    </div>
    <div class="tag-wrap">
      <div class="tag" v-if="dataItem.tag !== ''"><div class="smallfont">{{dataItem.tag}}</div></div>
      <!-- <div class="author txt van-ellipsis" v-if="dataItem.author !== ''">{{dataItem.author}}</div> -->
      <div class="office txt van-ellipsis" v-if="dataItem.source !== ''">{{dataItem.source}}</div>
      <div class="date txt van-ellipsis" v-if="dataItem.publish_date_format !== ''">{{dataItem.publish_date_format}}</div>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    dataItem: {
      type:Object,
      default:() => {
        return {}
      }
    }
  },
  data() {
    return {}
  }
}
</script>

<style lang="less" scoped>
.icell-wrap{
  height:100px;
  padding: 20px 15px;
  border-bottom: 1px solid #EFEFEF;
  .title {
    display: flex;
    height: 0.4rem;
    font-size:14px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:20px;
    .text{
      flex: 1;
    }
    .is_new{
      margin-left: 0.05rem;
      .is_new_item{
        width: 26px;
        height: 12px;
        margin-top: 3px;
        background:url(../assets/images/is_new.png) no-repeat;
        background-size: cover;
      }
    }
  } 
  .tag-wrap {
    display: flex;
    display: flex;
    align-items: center;
    margin-top: 0.08rem;
    & > div {
      margin-right: 0.16rem;
    }
    .office{
      max-width: 1.8rem;
    }
    .tag{
      min-width: 0.48rem;
      height: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      background:rgba(13,158,224,0.14);
      border-radius:2px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(13,158,224,1);
    }
    .date{
      min-width: 0.68rem;
    }
    .txt{
      font-size:12px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(153,153,153,1);
      line-height:12px;
    }
  }
}

.smallfont{
  font-size:12px;
  transform: scale(0.8)
}
</style>